import React from 'react';
import {
  Box,
  Typography
} from '@mui/material';
import { shades } from '../../../../theme.js';

const NoGroups = () => {
  return (
    <Box sx={{
      textAlign: 'center',
      mt: 4,
      mb: 4,
      border: '1px solid #ddd',
      p: 4,
      borderRadius: 4
    }}
    >
      <Typography variant='h6' sx={{ color: shades.neutral[900] }}>No Groups</Typography>
      <Typography variant='body1' sx={{ color: shades.neutral[500] }}>You are not a member of any groups.</Typography>
    </Box>
  );
};

export default NoGroups;
